import { ComplainDetailView } from "@/components/dashboard/shared/pages/ComplaintsPage"
import { useNavigate } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export function ComplaintDetailsPage({ complaintId }: { complaintId: string }) {
  const navigate = useNavigate()
  const currentUser = useAuthStore((s) => s.user)
  const handleGoBack = () => {
    navigate({ to: "/complaints" })
  }

  return (
    <ComplainDetailView
      id={complaintId}
      onBack={handleGoBack}
      currentUser={currentUser}
      isAdmin={false}
    />
  )
}
